import { forwardRef } from "react";
import type { HTMLAttributes } from "react";

import { cn } from "@/lib/helpers/cn";

type Card2Props = HTMLAttributes<HTMLElement> & {
  as?: "div" | "section" | "header" | "footer";
};

export const Card2 = forwardRef<HTMLElement, Card2Props>(function Card2(
  { as, className, ...props },
  ref,
) {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const Body = (as ?? "div") as any;

  return (
    <Body
      className={cn("tw:flex tw:rounded-md tw:bg-fill-white tw:shadow-lg", className)}
      ref={ref}
      {...props}
    />
  );
});
